import styled from "styled-components";
import { Col } from "antd";
import { SectionTopHeading } from "../../../../../../CommonComponents/commonStyles";

export const TableCircleName = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: normal;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  margin-top: 1.65rem;
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.h5};
    margin-top: 15px;
  }
  
`;

export const ChartPlacement = styled.div`
  margin-left: -10px;
  margin-top: 8px;
`;

export const InvestmentPerformanceDiv = styled.div`
  border-bottom: 2px solid #9b9b9b;
  margin-bottom: 50px;
  position: relative;
  overflow: hidden;
`;
export const PerformanceData = styled.div`
  overflow-y: scroll;
  max-height: 400px;
  .ant-progress-text {
    font-family: ${props => props.theme.fontFamily.helveticaNeueLight};
    font-size: ${props => props.theme.fontSize.heading};
    font-style: normal;
    font-stretch: ${props => props.theme.fontStretch.normal};
    line-height: normal;
    letter-spacing: ${props => props.theme.letterSpacing.zero};
    color: ${props => props.theme.fontColors.textColor};
  }
`;

export const LinkDiv = styled.div`
padding-top: 12.8px;
`;

export const CategoryName = styled(SectionTopHeading)`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media only screen and (max-width: 576px) {
    margin: 40px 0 20px 0;
    font-size: ${props => props.theme.fontSize.h4};
    line-height: ${props => props.theme.lineHeight.h4};
  }
`;

export const PerformanceCol = styled(Col)`
  margin-top: 7px;
  @media only screen and (max-width: 990px) {
    margin-top: 8px;
  }
`;
